import { render, staticRenderFns } from "./AddWizard.vue?vue&type=template&id=52eef1e0&"
import script from "./AddWizard.vue?vue&type=script&lang=js&"
export * from "./AddWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports